<div class="composer-wrapper" [ngClass]="{ 'composer-disabled': processing }">
  <ng-content select="[composerBanner]"></ng-content>
  <div class="textarea-wrapper">
    <textarea
      #composerTextArea
      [(ngModel)]="messageText"
      [disabled]="!!disabled || !!readonly"
      class="composer-textarea"
      [placeholder]="placeholder"
      [rows]="textAreaMinRows || 1"
      (keydown.enter)="enterKeySendsMessage ? sendMessage($event) : null"
      [attr.enterkeyhint]="enterKeySendsMessage ? 'send' : null"
      [maxlength]="maxlength || null"
      (input)="resizeTextArea()"
    ></textarea>
  </div>
  <div class="controls-and-actions">
    <ng-content select="glxy-composer-actions" />
    <div class="controls">
      @if ((chatSources()?.length ?? 0) > 0) {
        @if (chatSources()?.length === 1) {
          <div class="single-source-info">{{ chatSourceLabel() }}</div>
        } @else {
          <div class="chat-source-select">
            <span class="send-via">Send via</span>
            <button mat-stroked-button class="source-item" [matMenuTriggerFor]="sourceMenu">
              <div class="menu-button-content">
                @if (currentSource?.materialIcon) {
                  <mat-icon class="source-icon material-icon">{{ currentSource?.materialIcon }}</mat-icon>
                } @else if (currentSource?.icon) {
                  <div class="source-icon source-{{ currentSource?.icon }}"></div>
                } @else {
                  <div class="source-icon source-{{ currentSource?.id }}"></div>
                }
                @if (showFullSourceName) {
                  <div class="source-name">
                    @if (needsTranslation(currentSource)) {
                      {{ currentSourceDisplayName | translate }}
                    } @else {
                      {{ currentSourceDisplayName }}
                    }
                  </div>
                }
                <mat-icon iconPositionEnd class="drop-down">arrow_drop_down</mat-icon>
              </div>
            </button>
          </div>
        }
      }
      <ng-content select="glxy-composer-beside-send" />
      @if ({ processing }; as state) {
        <button
          mat-flat-button
          color="primary"
          (click)="sendMessage()"
          [disabled]="state.processing || disabled"
          [class.mat-custom-color]="customColor"
        >
          <glxy-button-loading-indicator [isLoading]="!!state.processing">
            {{ sendText }}
          </glxy-button-loading-indicator>
        </button>
      }
    </div>
  </div>
</div>

<!-- Sources Menu -->
<mat-menu #sourceMenu="matMenu" xPosition="before" class="fit-content">
  @for (item of chatSources(); track item.id) {
    <button mat-menu-item class="source-item" (click)="changeChatSourceId(item.id, true)">
      <div class="menu-item-content">
        @if (item.materialIcon) {
          <mat-icon class="source-icon material-icon">{{ item.materialIcon }}</mat-icon>
        } @else if (item.icon) {
          <div class="source-icon source-{{ item.icon }}"></div>
        } @else {
          <div class="source-icon source-{{ item.id }}"></div>
        }
        <div class="source-name-and-account">
          <div class="source-name">
            @if (needsTranslation(item)) {
              {{ item.sourceName | translate }}
            } @else {
              {{ item.sourceName }}
            }
          </div>
          @if (item.account) {
            <small class="account">
              @if (needsTranslation(item)) {
                {{ item.account | translate }}
              } @else {
                {{ item.account }}
              }
            </small>
          }
        </div>
      </div>
    </button>
  }
</mat-menu>
